import { forwardRef } from "react"

import { TransferPrintViewTable } from "./TransferPrintViewTable"
import { TransferTypeChip } from "./TransferTypeChip"

import { DATE_FORMAT } from "@/constants/formats"
import type { Transfer } from "@/graphql/codegen/graphql"
import { InventoryWorkOrderPrintLayout } from "@/screens/Inventory/components"
import { formatDate } from "@/utils/date"
import { formatWarehouseLabel } from "@/utils/warehouse"

interface TransferWorkOrderPrintViewProps {
  transfer: Transfer
}

export const TransferWorkOrderPrintView = forwardRef<HTMLDivElement, TransferWorkOrderPrintViewProps>(
  ({ transfer }, ref) => (
    <InventoryWorkOrderPrintLayout
      ref={ref}
      title={`Work Order Slip: ${transfer.referenceCode}`}
      chip={<TransferTypeChip type={transfer.transferType} />}
      workDate={formatDate(transfer.createdOn, DATE_FORMAT.US)}
      warehouseLabel={formatWarehouseLabel(transfer.sourceWarehouseArea)}
    >
      <TransferPrintViewTable transfer={transfer} />
    </InventoryWorkOrderPrintLayout>
  )
)
